// extracted by mini-css-extract-plugin
export default {"tabletBookingContainer":"HallContainer_tabletBookingContainer__2SpjE"};